import { render, staticRenderFns } from "./SubnetInfo.vue?vue&type=template&id=75055662&scoped=true"
import script from "./SubnetInfo.vue?vue&type=script&lang=js"
export * from "./SubnetInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75055662",
  null
  
)

export default component.exports